import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from 'app/components/alert/alert.module';
import { OfferSmartComponent } from './offer-smart/offer-smart.component';
import { OfferComponent } from './offer/offer.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CreateOfferButtonComponent } from './create-offer-button/create-offer-button.component';
import { PublishOfferDialogComponent } from './publish-offer-dialog/publish-offer-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatMenuModule } from '@angular/material/menu';
import { FormlyDialogModule } from 'ng2-app/components/formly-dialog/formly-dialog.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { OfferSnackBarDataComponent } from './offer-snack-bar-data/offer-snack-bar-data.component';
import { SingleOfferSmartComponent } from './single-offer-smart/single-offer-smart.component';
import {OfferOptionModule} from 'ng2-app/offer-option/offer-option.module';
import { FinancingValuePropsModule } from 'ng2-app/financing-value-props/financing-value-props.module';
import { RecommendOptionToggleModule } from 'ng2-app/components/recommend-option-toggle/recommend-option-toggle.module';
import { DeclineInfoDialogModule } from 'ng2-app/components/decline-info-dialog/decline-info-dialog.module';
import { DeclineReasonsDialogModule } from 'ng2-app/components/decline-reasons/decline-reasons-dialog.module';

@NgModule({
    declarations: [
        OfferSmartComponent,
        OfferComponent,
        CreateOfferButtonComponent,
        OfferSnackBarDataComponent,
        PublishOfferDialogComponent,
        SingleOfferSmartComponent,
    ],
    imports: [
        CommonModule,
        MatExpansionModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        FormlyModule,
        MatMenuModule,
        FormlyDialogModule,
        MatProgressSpinnerModule,
        AlertModule,
        MatSnackBarModule,
        OfferOptionModule,
        FinancingValuePropsModule,
        RecommendOptionToggleModule,
        DeclineInfoDialogModule,
        DeclineReasonsDialogModule,
    ],
    exports: [
        OfferSmartComponent,
        SingleOfferSmartComponent,
    ]
})
export class OfferModule { }
